import { ThemeButtonKeys } from '../../../styles/tokens/buttons';
import { ThemeColorsKeys } from '../../../styles/tokens/colors';

interface Tokens {
  logOutButtonVariant: ThemeButtonKeys;
  contactIconColor: ThemeColorsKeys | 'currentColor';
  enableCallToActionButton: boolean;
  enableSearch: boolean;
  hoverColour: ThemeColorsKeys;
}

const tokens: Tokens = {
  logOutButtonVariant: 'secondaryOutline',
  contactIconColor: 'currentColor',
  enableCallToActionButton: true,
  enableSearch: true,
  hoverColour: 'brandTwo100',
} as const;

export default tokens;
